import { Controller } from "stimulus"

export default class extends Controller {
  approveAdministrator() {
    const id = this.element.dataset.id
    const csrfToken = document.querySelector("[name='csrf-token']").content;

    fetch("/administration/administrators/approve_administrator", {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": csrfToken, // Set the token
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id, // params with id of the user
      }),
    });
  }
}
